import {Button, notification, Row, Col} from "antd";
import React, {useEffect, useState} from "react";
import {approveOrderService} from "../../../../services/approve-order.service";
import { distributionCenterService } from "../../../../services";
import CorrespondentBankFields from "../../edit-legal-entity-new/belarus-legal-entity/steps/correspondent-bank-fields";
import Text from "antd/lib/typography/Text";
import i18n from "../../../../i18n";

export default function ReapproveOrder({legalEntityID, shipperCompanyID, needUpdate, onSuccess}) {
    const [distributionCentersList, setDistributionCentersList] = useState([]);
    const [stepFields, setFields] = useState({
        correspondentBankName: '',
        correspondentBankInn: '',
        correspondentBankBic: '',
        correspondentBankLegalAddress: '',
        correspondentBankAccount: '',
        correspondentBankCheckingAccount: '',});
    const [fieldsErrors, setFieldsErrors] = useState({});
    const [isDisabled, setIsDisabled] = useState(false);

    useEffect(() => {
        if (needUpdate) {
            setDistributionCentersList([]);

            distributionCenterService.getCompanies(true, true, null, shipperCompanyID)
                .then((response) => {
                    setDistributionCentersList(response);
                })
                .catch((err) => {
                    notification.error({
                        message: i18n.t('components.notification.titles.getCompanies2'),
                        description: err,
                    });
                });
        }
    }, [needUpdate]);

    const getFieldErrors = (fieldName) => {
        if(fieldsErrors === "undefined") {
            return null;
        }
        return typeof fieldsErrors[fieldName] !== "undefined"
            ? fieldsErrors[fieldName].reduce((fieldErrors, error) => {
            return fieldErrors + "; " + error;
            })
            : null;
    };

    const ordersButtonsRender = () => {
        return distributionCentersList.map((distCenter) => {
            if (distCenter.IsActive) {
                return (
                    <Col lg={8} sm={24}>
                        <Button style={buttonStyle} onClick={() => handleSendReapprove(distCenter.Id)} className="small-button typical-btn-green">
                            {distCenter.VisibleName}
                        </Button>
                    </Col>
                );
            }
            return null;
        })
    };

    const buttonStyle = {
        width: '290px'
    };

    const handleSendReapprove = (distCenterId) => {
        setIsDisabled(true);
        approveOrderService.reapproveOrder(legalEntityID, shipperCompanyID, distCenterId, stepFields)
            .then(resp => {
                if (resp.code !== 400) {
                    notification.success({
                        message: "Отправка заявки",
                        description: resp.message,
                    });
                    onSuccess();
                } else {
                    notification.error({
                        message: "Отправка заявки",
                        description: resp.message,
                    });
                    if(resp.errors !== "undefined") {
                        setFieldsErrors(resp.errors);
                    }
                }
            })
            .catch(errMsg => {
                notification.error({
                    message: "Отправка заявки",
                    description: errMsg,
                });
            }).finally(() => {
                setIsDisabled(false);
            });
    }

    return (
        <>
            <Row>
                <Col>
                <Text strong>
                    <h2>ВНИМАНИЕ!!!</h2>
                    <p>Для заключения договора с данной компанией вам необходимо пройти повторное согласование юр. лица</p>
                    <p>Для этого заполните данные и выберите РЦ для согласования</p>
                    <p>После отправки данных и до согласования грузоотправителем ваше юр. лицо остаётся неактивным, в это время вы не можете записываться на ЛЮБЫЕ рейсы
                    </p>
                </Text>
                </Col>
            </Row>
            <Row>
                <CorrespondentBankFields
                    setFields={setFields}
                    stepFields={stepFields}
                    getFieldErrors={getFieldErrors}
                    edit={true}
                />
            </Row>
            <Row>
                <Col>
                    <p>Пересогласование в:</p>
                    {ordersButtonsRender()}
                </Col>
            </Row>
        </>
    );
}
